import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { AuthService } from './auth.service'
import { LoadingComponent } from '../shared/loading.component'

@Component({
  selector: 'app-auth-callback',
  templateUrl: './auth-callback.component.html',
  styleUrls: ['./auth-callback.component.scss']
})
export class AuthCallbackComponent implements OnInit {

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService) { }

  ngOnInit() {
    this.authService.getUser().subscribe(
      (user) => {
        this.authService.storeUser(user);
        this.authBack();
      },
      (error) => {
        this.router.navigate(["/"]);
      }
    )
  }

  authBack() {
    let authBack = localStorage.getItem('authBack');
    if (authBack != null) {
      localStorage.removeItem('authBack')
      window.location.replace(authBack);
    } else {
      window.location.replace('/root');
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/auth/auth-callback.component.ts